import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: () => import('@/views/OnboardingWizard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/farms',
    name: 'Farms',
    component: () => import('@/views/farms/FarmList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/farms/:id',
    name: 'FarmDetail',
    component: () => import('@/views/farms/FarmDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ponds',
    name: 'Ponds',
    component: () => import('@/views/ponds/PondList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ponds/:id',
    name: 'PondDetail',
    component: () => import('@/views/ponds/PondDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory',
    name: 'FishInventory',
    component: () => import('@/views/inventory/FishInventory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory/:id',
    name: 'BatchDetail',
    component: () => import('@/views/inventory/BatchDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/water-quality',
    name: 'WaterQuality',
    component: () => import('@/views/water-quality/WaterQuality.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/feeding',
    name: 'Feeding',
    component: () => import('@/views/feeding/FeedingSchedule.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/feed-inventory',
    name: 'FeedInventory',
    component: () => import('@/views/feeding/FeedInventory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/financial',
    name: 'Financial',
    component: () => import('@/views/financial/FinancialDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/reports/ReportDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/users/UserList.vue'),
    meta: { requiresAuth: true, roles: ['admin', 'manager'] }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('@/views/companies/CompanyList.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  console.log('Router guard:', { to: to.path, from: from.path, isAuth: authStore.isAuthenticated })

  if (authStore.token && !authStore.user) {
    await authStore.fetchUser()
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    console.log('Redirecting to login - not authenticated')
    next('/login')
    return
  }

  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    console.log('Redirecting to home - already authenticated')
    next('/')
    return
  }

  const allowedRoles = to.meta.roles as string[] | undefined
  if (allowedRoles && (!authStore.user || !allowedRoles.includes(authStore.user.role))) {
    console.log('Redirecting - insufficient role')
    next('/')
    return
  }

  next()
})

export default router